import { SET_MEDIA_UPLOAD_SELECTION } from 'actions';
import { IBrowserImage } from 'typings';

export function setMediaUploadSelection(mediaUploadSelection?: IBrowserImage) {
  return { mediaUploadSelection, type: SET_MEDIA_UPLOAD_SELECTION };
}
